import { EditorState, EditorStatus, DiscountSaveStatus, SaveErrorValue } from "app/pages/DiscountEditor/modules/Editor/state";
import { SaveDiscountErrorCategory } from "app/shared/model/SaveDiscountResultDto";

function getRoot(state: any) : EditorState {
    return state.editor;
}

export function getId(state: any) {
    const root = getRoot(state);
    if (root.status === EditorStatus.NoRecord)
        return '';

    return root.id;
}

export function hasBeenSaved(state: any) : boolean {
    const root = getRoot(state);
    if (root.status == EditorStatus.NoRecord)
        return false; 
    return root.savedNumber > 0; 
}

export function getDiscountSaveStatus(state: any) : DiscountSaveStatus {
    const root = getRoot(state);
    if (root.status == EditorStatus.NoRecord)
        return DiscountSaveStatus.NoChanges;

    if (root.savingNumber)
        return DiscountSaveStatus.SavingChanges;

    return root.savedNumber < root.changeNumber
        ? DiscountSaveStatus.ChangesToSave
        : DiscountSaveStatus.NoChanges;
}

export function hasSaveError(state: any) : SaveErrorValue {
    const root = getRoot(state);
    if (root.status == EditorStatus.NoRecord)
        return SaveErrorValue.NoError;

    return root.saveError;
}

export function getSectionError(state: any, category: SaveDiscountErrorCategory) : string|undefined {
    const root = getRoot(state);
    if (root.status == EditorStatus.NoRecord)
        return undefined;

    const error = root.errors[category];
    if (!error || error.length === 0)
        return undefined;

    return error[0];
}

export function getAllErrors(state: any) : { [category: string]: string[] } {
    const root = getRoot(state);
    if (root.status == EditorStatus.NoRecord)
        return {};
    
    return root.errors || {};
}

export function shouldShowSuccessMessage(state: any) : boolean {
    const root = getRoot(state);
    if (root.status == EditorStatus.NoRecord)
        return false;
    
    return root.showSuccessMessage === true;
}